import { Controller, useFormContext } from 'react-hook-form';
import { Grid, Radio, FormControlLabel, FormControl, FormLabel, RadioGroup, FormHelperText } from '@mui/material';

const LANGUAGE_RADIOS = [
  { label: 'English', value: 'English' },
  { label: 'Russian', value: 'Russian' },
];

export const StepLifestyleManagement = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container>
      <Grid item xs={12}>
        <FormControl component='fieldset' error={!!errors.personalAssistantLanguage}>
          <FormLabel component='legend'>Please select the language of preference for communications with your Personal Assistant *</FormLabel>
          <RadioGroup aria-label='position' row>
            {LANGUAGE_RADIOS.map((radio, idx) => (
              <FormControlLabel
                key={idx}
                label={radio.label}
                labelPlacement='end'
                control={
                  <Controller
                    name='personalAssistantLanguage'
                    control={control}
                    rules={{ required: 'Language is required' }}
                    render={({ field }) => <Radio {...field} color='primary' value={radio.value} checked={radio.value === field.value} />}
                  />
                }
              />
            ))}
          </RadioGroup>
          {errors.personalAssistantLanguage?.message && <FormHelperText>{errors.personalAssistantLanguage?.message as string}</FormHelperText>}
        </FormControl>
      </Grid>
    </Grid>
  );
};
